import { getToken } from '@helpers/user';

/**
 * Adds authorization header to axios request
 * @param {AxiosRequest} request Axios request
 * @returns {AxiosRequest} Updated request
 */
const addAuth = request => {
  if (!request.noAuth) {
    const token = getToken();
    request.headers.Authorization = token ? `JWT ${token}` : '';
  }

  return request;
};

export default addAuth;
